import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Ткачук Олександр',
  role: 'Голова антидопінгової комісії',
  email: 'kyiv.climber@gmail.com'
}, {
  name: 'Маренич Валентина',
  role: 'Членкиня антидопінгової комісії',
  email: 'vertykal.kh@gmail.com'
}, {
  name: 'Шалагін Михайло',
  role: 'Член антидопінгової комісії',
  email: 'mihashalagin@gmail.com'
}];
export function AntidopingCommission() {
  return <FederationMembersPage title="Антидопінгова комісія" subtitle="Антидопінгова комісія скельного комітету ФАіСУ" members={members} data-id="element-520" />;
}